import { StructuredQuote } from '@store/Quote/Quote.types';
import { addDays } from 'date-fns';
import { formatDateToTimezone, ShortDateFormat } from '@utils/date';
import { getAddressFromQuoteItemAttributeTypes } from '@utils/address';

import { GroupedQuote } from '@lio/rule-engine/utils/quote-details';
import { getEngine } from '@lio/rule-engine';

export const getEventRows = (structuredQuote: StructuredQuote) => {
  const events = structuredQuote.quoteItems.filter((qi) => qi.quoteItemType.codeName === 'LiabilityClass');

  const ruleEngine = getEngine(structuredQuote as GroupedQuote);

  const goodEvents = events.filter((e) => {
    ruleEngine.setEngineInitialQuoteItem(e.id);

    const { GLClassificationCode } = e.attributeTypes;

    const classCodeValue = GLClassificationCode?.attribute?.valueOverride ?? GLClassificationCode?.attribute?.value;
    if (classCodeValue !== '63217' && classCodeValue !== '63218') {
      return false;
    }

    return true;
  });

  return goodEvents.flatMap((event, index) => {
    ruleEngine.setEngineInitialQuoteItem(event.id);
    const { GLClassificationName, ASActivity, SpectatorsCount, DaysCount, GLASStartDate } = event.attributeTypes;

    const startDate = (GLASStartDate?.attribute?.valueOverride ?? GLASStartDate?.attribute?.value) as string;
    const daysCount = (DaysCount?.attribute?.valueOverride ?? DaysCount?.attribute?.value) as string;
    const eventStartDate = startDate ? new Date(startDate) : null;
    const eventEndDate = startDate && daysCount ? addDays(new Date(startDate), parseInt(daysCount)) : null;

    const locationQI = structuredQuote.quoteItems.find((qi) => qi.id === event.parentId);
    const venueAddress = getAddressFromQuoteItemAttributeTypes(locationQI);
    const attendeesCount = Number(SpectatorsCount.attribute?.valueOverride ?? SpectatorsCount.attribute?.value) || 0;

    const isStartDateActive = ruleEngine.execute(GLASStartDate.isActive);

    return [
      {
        titleRow: true,
        id: `${event.id}-event`,
        title: `Event ${index + 1}`,
        value: '',
        isVisible: true,
      },
      {
        id: `${event.id}-glClassification`,
        title: 'Name',
        value: GLClassificationName.attribute?.valueOverride ?? GLClassificationName.attribute?.value ?? '',
        isActive: ruleEngine.execute(GLClassificationName.isActive),
      },
      {
        id: `${event.id}-asActivity`,
        title: 'Type',
        value: ASActivity.attribute?.valueOverride ?? ASActivity.attribute?.value ?? '',
        isActive: ruleEngine.execute(ASActivity.isActive),
      },
      {
        id: `${event.id}-spectatorsCount`,
        title: 'Number of Spectators/Attendees',
        value: attendeesCount,
        isActive: ruleEngine.execute(SpectatorsCount.isActive),
      },
      { id: `${event.id}-venueAddress`, title: 'Venue Address', value: venueAddress, isActive: true },
      {
        id: `${event.id}-eventStartDate`,
        title: 'Event Start Date',
        value: eventStartDate ? formatDateToTimezone(eventStartDate, ShortDateFormat) : '',
        isActive: isStartDateActive,
      },
      {
        id: `${event.id}-eventEndDate`,
        title: 'Event End Date',
        value: eventEndDate ? formatDateToTimezone(eventEndDate, ShortDateFormat) : '',
        isActive: isStartDateActive && ruleEngine.execute(DaysCount.isActive),
      },
    ]?.filter((x) => {
      if (x.titleRow) {
        return true;
      }

      return x.isActive && x.value !== null && x.value !== '';
    });
  });
};
